/**
 * Normalizes a URL by adding https:// if no protocol is present.
 */
export function normalizeUrl(value: string): string {
  const trimmed = value.trim()

  if (!trimmed) return ''

  if (/^https?:\/\//i.test(trimmed)) return trimmed

  return `https://${trimmed}`
}

/**
 * Formats a URL for display by removing the protocol and optionally the www prefix.
 */
export function formatUrlForDisplay(url: string, removeWww = true): string {
  if (!url) return ''
  const pattern = removeWww ? /^https?:\/\/(www\.)?/i : /^https?:\/\//i
  return url.replace(pattern, '')
}
